// The dashed guide lines the chart draws for a symbol's alerts. Number(null) is 0, so a pattern or swing
// alert's null targetValue must never be read as a price: it would draw at 0.00 and squash the y-axis
// (DWLF-579). The level alone decides, not the alert type, so a new backend price type draws without this
// repo mirroring SPT's type list. That relies on SPT storing targetValue only on price alerts.
const ALERT_COLOR = 'rgba(255,165,0,0.9)';

const priceLevel = (value) => {
  if (typeof value === 'number') return Number.isFinite(value) ? value : null;
  if (typeof value === 'string' && value.trim() !== '') {
    const n = Number(value);
    return Number.isFinite(n) ? n : null;
  }
  return null;
};

// excludeIds: alerts drawn elsewhere (a chart alert line draws the alert it owns).
export function alertGuides(alerts, excludeIds = new Set()) {
  return (Array.isArray(alerts) ? alerts : [])
    .filter((alert) => !excludeIds.has(alert?.alertId))
    .map((alert) => ({ alert, level: priceLevel(alert?.targetValue) }))
    .filter(({ level }) => level !== null)
    .map(({ alert, level }) => ({ y: level, dashed: true, color: ALERT_COLOR, label: alert.label || 'Alert' }));
}
